import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SocialProof from "@/components/SocialProof";

// Lazy load below-the-fold components
const InteractiveDemo = lazy(() => import("@/components/InteractiveDemo"));
const MidCTA = lazy(() => import("@/components/MidCTA"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Process = lazy(() => import("@/components/Process"));
const TrustBadges = lazy(() => import("@/components/TrustBadges"));
const Comparison = lazy(() => import("@/components/Comparison"));
const Pricing = lazy(() => import("@/components/Pricing"));
const FAQ = lazy(() => import("@/components/FAQ"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Navbar />
      <Hero />
      <SocialProof />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <InteractiveDemo />
        <MidCTA />
        <Testimonials />
        <Process />
        <TrustBadges />
        <Comparison />
        <Pricing />
        <FAQ />
        <FinalCTA />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
